import React from 'react';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import CModal from '_Components/CModal/CModal';
import QModalSection from '_Components/Modals/QModalSection/QModalSection';
import QButton from '_Components/Buttons/QButton/QButton';
import { grayShades, red, purple } from 'styles/abstracts/colors';

const StyledQModalSection = styled(QModalSection)`
  padding-left: 3em;
  padding-right: 3em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  & > * {
    margin: 1em;
  }
`;

const StyledCModal = styled(CModal)`
  width: 500px !important;

  & .modal-content > *:first-child {
    padding-bottom: 0;
  }
`;

const ModalBodyContainer = styled.div`
  color: ${grayShades.g800};
  font-weight: bold;
  font-size: 15px;
`;

const DangerMessage = styled.div`
  color: ${red};
  font-weight: bold;
  font-size: 15px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const InfoSpan = styled.span`
  color: ${purple};
`;

const DeleteSelectionConfirmationModal = ({
  deleteConfirmButton,
  onDeleteCanceled,
  t,
  isOpen,
  selectedThematicSelectionOption,
}) => {

  const body = (
    <ModalBodyContainer>
      <ul>
        <li>{t('Selection name')} : <InfoSpan>{selectedThematicSelectionOption.name}</InfoSpan></li>
        {/* <li>{t('Description')} : <InfoSpan>{selectedThematicSelectionOption.description}</InfoSpan></li> */}
        <li>{t('Last modified')} : <InfoSpan>{selectedThematicSelectionOption.createdBy.firstName} {selectedThematicSelectionOption.createdBy.lastName}</InfoSpan></li>
        {/* <li>{t('On')} : <InfoSpan>{selectedThematicSelectionOption.createdBy.date}</InfoSpan></li> */}
      </ul>
      <DangerMessage>{t('This will delete')}</DangerMessage>
    </ModalBodyContainer>
  );

  const getFooter = () => {
    return (
      <>
        <StyledQModalSection>
          <QButton onClick={onDeleteCanceled} bgColor={grayShades.g800}>
            {t('button:Cancel')}
          </QButton>
          {deleteConfirmButton}
        </StyledQModalSection>
      </>
    );
  };

  return (
    <StyledCModal
      data={{}}
      title={t('Are you sure')}
      displayMentionsSubtitle={false}
      displayDateSubtitle={false}
      subtitleAdditionalContent={t('Do you really want to delete')}
      footer={getFooter()}
      modal={isOpen}
    >
      {body}
    </StyledCModal>
  );
};

export default withTranslation('selections', 'button')(DeleteSelectionConfirmationModal);
